<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [buildParams]="buildParams"
  [tableParams]="tableParams"
  [isDynamicListTable]="true"
>
</app-ag-grid-table>
